module.exports = __webpack_public_path__ + "img/security converted.d88b23ad.png";